import {translate} from 'views/module';

import {getParticipantName} from '../../communication/communicationUtils';

const formatJson = (value) => {
  if (value === undefined || value === null) {
    return '{}';
  }

  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return '{}';
  }
};

const parseJson = (value, label) => {
  try {
    return JSON.parse(value || '{}');
  } catch {
    throw new Error(translate('case.Detail.AgentJobs.InvalidJson', {label}));
  }
};

const formatPayloadDetail = (value) => {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }

  try {
    return JSON.stringify(value);
  } catch {
    return '';
  }
};

const getResourceLabel = (participantDetails, resourceRn) => {
  if (!resourceRn) {
    return '';
  }

  return getParticipantName(participantDetails, resourceRn) || resourceRn;
};

const getRecipientListDetail = (participantDetails, resourceRn) => {
  const resourceLabel = getResourceLabel(participantDetails, resourceRn);
  return resourceLabel ? translate('case.Detail.AgentJobs.List.ToRecipient', {recipient: resourceLabel}) : '';
};

const getAgentJobExecutionSortTime = (job) => {
  const executeAtTime = new Date(job.executeAt).getTime();

  if (!Number.isNaN(executeAtTime)) {
    return executeAtTime;
  }

  const createdAtTime = new Date(job.createdAt).getTime();

  return Number.isNaN(createdAtTime) ? 0 : createdAtTime;
};

const sortAgentJobsByExecutionTime = (agentJobs) => {
  return [...agentJobs].sort((firstJob, secondJob) => {
    return getAgentJobExecutionSortTime(firstJob) - getAgentJobExecutionSortTime(secondJob);
  });
};

export {
  formatJson,
  formatPayloadDetail,
  getRecipientListDetail,
  getResourceLabel,
  parseJson,
  sortAgentJobsByExecutionTime,
};
